/**
 * Color palette for loop visualization
 */

/**
 * Predefined colors for loops
 * Auto-cycles when more than 8 loops
 */
export const LOOP_COLORS = [
    '#4CAF50', // Green
    '#2196F3', // Blue
    '#FF9800', // Orange
    '#9C27B0', // Purple
    '#00BCD4', // Cyan
    '#E91E63', // Pink
    '#FFEB3B', // Yellow
    '#795548', // Brown
] as const;

/**
 * Get color for a loop based on its index
 */
export function getLoopColor(index: number): string {
    return LOOP_COLORS[index % LOOP_COLORS.length];
}

/**
 * Get next available color for a new loop
 */
export function getNextLoopColor(existingLoopsCount: number): string {
    return getLoopColor(existingLoopsCount);
}
